module.exports = __webpack_public_path__ + "img/katana_px.57ab3e00.png";